import React, { useRef, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './Caroussel.css';
import LazyLoad from 'react-lazyload';

function Carousel() {

  const carouselRef = useRef(null);

  useEffect(() => {
    // Démarre le carrousel lors du chargement du composant
    const carousel = carouselRef.current;
    const carouselInstance = new window.bootstrap.Carousel(carousel);

    // Arrête le carrousel lorsqu'on survole
    carousel.addEventListener('mouseenter', () => {
      carouselInstance.cycle();
    });

    // Redémarre le carrousel lorsqu'on ne survole plus
    carousel.addEventListener('mouseleave', () => {
      carouselInstance.cycle();
    });

    // Nettoyage lors du démontage du composant
    return () => {
      carousel.removeEventListener('mouseenter', () => { });
      carousel.removeEventListener('mouseleave', () => { });
    };
  }, []);


  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <div
        ref={carouselRef}
        id="carouselExampleFade"
        className="carousel slide carousel-fade"
        data-ride="carousel"
        data-interval="500"
      >
        <div className="carousel-inner">
        <LazyLoad height={200} offset={100}>
          <div className="carousel-item active">
            <img
              src="../images/taille.jpg"
              className="d-block w-100 carousel-image"
              alt="image1"
            />
          </div>
          <div className="carousel-item">
            <img
              src="../images/carou21.jpg"
              className="d-block w-100 carousel-image"
              alt="image2"
            />
          </div>
          <div className="carousel-item">
            <img
              src="../images/taille_2.jpg"
              className="d-block w-100 carousel-image"
              alt="image3"
            />
          </div>
          <div className="carousel-item">
            <img
              src="../images/interior.jpg"
              className="d-block w-100 carousel-image"
              alt="image4"
            />
          </div>
          <div className="carousel-item">
            <img
              src="../images/modern-f.jpg"
              className="d-block w-100 carousel-image"
              alt="image5"
            />
          </div>
          </LazyLoad>
        </div>
        <a className="carousel-control-prev" href="#carouselExampleFade" role="button" data-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="sr-only">Previous</span>
        </a>
        <a className="carousel-control-next" href="#carouselExampleFade" role="button" data-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="sr-only">Next</span>
        </a>
      </div>
    </>
  );
}

export default Carousel;
